module.exports = __webpack_public_path__ + "static/media/schedule_structure_change_period_time.ceb135ca.mov";